import { filterConfigs, getConfig } from './config';
import { GrayParams, GraySyncParams } from './type';
import { user, CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';

/**
 * 用户是否在灰度逻辑中，可能是命中白名单，也可能是命中灰度策略
 * @param params 灰度逻辑配置参数，传入的 business 需与配置中心定义的 business 名称一致。若只有一项灰度，name可以不传入，默认取配置第一项
 * @returns
 */
export const isGrayUser = async (params: GrayParams): Promise<boolean> => {
  const [error, config] = await to(getConfig(params));
  if (error) {
    console.error('无法获取灰度配置链接，默认返回非灰度用户');
    new CustomException(error, 'getGrayConfigError', `business: ${params.business} name: ${params.name}`);
    return false;
  }
  return isGrayUserSync({
    ...params,
    config,
  });
};

/**
 * 用户是否在灰度逻辑中，可能是命中白名单，也可能是命中灰度策略, 同步方法
 * @param params 灰度逻辑配置参数，传入的 business 需与配置中心定义的 business 名称一致。若只有一项灰度，name可以不传入，默认取配置第一项
 * @returns
 */
export const isGrayUserSync = (params: GraySyncParams): boolean => {
  const { uin = user.getUin(), name, config } = params;
  // 获取uin中的最后一位数字
  const currentTail = uin.replace(/[a-zA-Z_@.-]/g, '').slice(-1);

  const currentConfig = filterConfigs(config, name);
  // 未找到配置，则默认未命中灰度
  // ? 是否需要抛异常告警?
  if (!currentConfig) {
    console.error('未找到对应的灰度配置');
    return false;
  }
  const { pattern = '', whiteList = '', all = false } = currentConfig;
  // 先检查是否全部放量，或者为白名单用户
  if (all || whiteList.includes(uin)) {
    return true;
  }
  // 再检查是否为正则匹配灰度用户。需排除 pattern 为 '' 的情况，否则 /^$/ 匹配任何字符串
  return pattern !== '' && new RegExp(pattern).test(currentTail);
};
